<template>
  <div>
    <p class="asc-terms-and-conditions--body__text">
      USER acknowledges and agrees that the data and information contained in
      the documents set forth on this website is provided by Collins Aerospace
      (“Collins”) to USER for informational purposes only and is provided to
      USER in an as-is condition with no warranties either express or implied.
      Any decision to remove any equipment from an aircraft based on the
      information set forth herein is at USER’S own discretion. Collins does not
      accept any liability, and USER waives any and all liability, for USER’S
      action or inaction, whether based on data provided or not provided through
      this website.
    </p>
    <p class="asc-terms-and-conditions--body__text">
      The data contained in the documents set forth on this website is owned by
      Collins and Collins proprietary data. The data is disclosed in confidence
      and is intended for internal use only by Collins authorized owner/lessee
      operators and repair stations. The data shall not be altered, re-used,
      disclosed to others or reproduced for distribution or redistribution in
      any form, paper or electronic, without the express prior written consent
      of Collins, which consent shall be in Collins’ sole and absolute
      discretion. This includes but is not limited to the use of the data in the
      creation, manufacture, development or derivation of any repairs,
      modifications, parts, spare parts, design or configuration changes, or to
      obtain FAA or any other government or regulatory approval to do so. If
      consent is given for reproduction in whole or part, the terms and
      conditions set forth herein shall appear in any such reproduction in
      whole. The data contained in the documents set forth in this website was
      developed specifically for systems and/or parts manufactured by or for
      Collins or approved by Collins. The data may not be applicable to any
      other systems and/or parts, regardless of their apparent similarity to
      systems and/or parts manufactured by or for Collins or approved by
      Collins.
    </p>
    <p class="asc-terms-and-conditions--body__text">
      USER agrees that it shall not rely in any way on data in these documents
      to maintain or otherwise support systems and/or parts that were not
      manufactured by or for Collins or approved by Collins. USER agrees that in
      no event shall Collins’ action or inaction with respect to the terms set
      forth herein constitute a waiver of Collins’ rights. In the event that
      Collins waives any of its rights under these terms and conditions, it will
      do so in writing. In such case, Collins’ specific waiver shall not
      constitute a future waiver of any of the rights described herein. By
      accepting this Data Use Agreement terms and conditions or by accessing the
      documents on this website, the USER agrees to use the data in full
      compliance of the Data Use Agreement. USER also agrees to only access data
      for aircraft the user's company is an owner/lessee operator or where user
      has received prior written consent from Collins.
    </p>
  </div>
</template>

<script>
export default {
  name: 'AscTermsAndConditions',
}
</script>
